import { Ng2StateDeclaration } from '@uirouter/angular';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { BusinessUnitListComponent } from '@fi-app/business-unit/business-unit-list/business-unit-list.component';

export const FiBusinessUnitListState: Ng2StateDeclaration = {
    name: FiStateNames.BusinessUnit.List,
    url: '/?:sortColumn&:sortDirection&:offset&:BusinessUnitId',
    component: BusinessUnitListComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, FiBusinessUnitListStateResolve_pageTitle],
    },
    data: {
        addSref: FiStateNames.BusinessUnit.AddV2,
    },
};

export function FiBusinessUnitListStateResolve_pageTitle(pageTitleService: PageTitleService) {
    return pageTitleService.setTitleByItem(ObjectTypes.BusinessUnit);
}
